import { render } from "./PartnersReportPage.vue?vue&type=template&id=4b0e988a"
import script from "./PartnersReportPage.vue?vue&type=script&lang=js"
export * from "./PartnersReportPage.vue?vue&type=script&lang=js"

import "./PartnersReportPage.vue?vue&type=style&index=0&id=4b0e988a&lang=scss"

import exportComponent from "/home/mon3m/mon3m/dafater/ManageSPA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__